import { Divider, Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import EmployeePersonalForm from '@/components/Employee/EmployeePersonalForm';
import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import { PageProps } from '@/types/PageProps';
import { useEmployeeCreate } from '@/core/domain/enterprise/Employees/Employees.hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';

const CreateEmployeePage = ({ route }: PageProps) => {
  const history = useHistory();

  const [form] = Form.useForm();

  const employeeCreate = useEmployeeCreate();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const obj = {
        ...values,
        companiesIds: values.companiesIds,
        birthday: values.birthday?.toISOString(),
        photo: values.photo?.length
          ? values.photo[0].response?.filePath
          : undefined,
      };

      const result = await employeeCreate.mutateAsync(obj);

      history.push(`/app/registry/employees/${result.id}`);
    } catch {}
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSaveClick}
          loading={employeeCreate.isLoading}
        >
          <FormattedMessage id="commons.form.button.save" />
        </SaveButton>
      }
    >
      <EmployeePersonalForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/registry/employees" />
      </SpaceForButton>
    </TabContentWrapper>
  );
};

export default CreateEmployeePage;
